import { post } from './utility/Requests.default';

export function revokeAuth0RefreshTokenForUser(refreshToken: string) {
    return post('/api/users/revokeAuth0RefreshTokenForUser', { body: { refreshToken } });
}
